<div class="page-title animatedBackground">
    <div class="container">
        <h3>Contact</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Contact</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="contact-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="contact-box">
                    <div class="icon">
                        <i class="icofont-phone"></i>
                    </div>
                    <div class="content">
                        <h3>Phone / Fax</h3>
                        <p><a href="tel:920006748">920006748</a></p>
                        <p><a href="tel:+966114917224">(+966) 11 49 172 24</a></p>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6">
                <div class="contact-box">
                    <div class="icon">
                        <i class="icofont-envelope"></i>
                    </div>
                    <div class="content">
                        <h3>E-mail</h3>
                        <p><a href="mailto:sales@osit.com.sa">sales@osit.com.sa</a></p>
                        <p><a href="mailto:support@osit.com.sa">support@osit.com.sa</a></p>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                <div class="contact-box">
                    <div class="icon">
                        <i class="icofont-google-map"></i>
                    </div>
                    <div class="content">
                        <h3>Location</h3>
                        <p>7843 Eastern Ring Road, Al Rayyan<span> <br> Riyadh 14211-2294 Saudi Arabia</span></p>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-12 col-md-12">
                <div id="map">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1812.2246821597907!2d46.765322663445524!3d24.711448552471804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f01464c51ec8b%3A0x961401f23e215927!2z2LTYsdmD2Kkg2KfZhNio2LHYp9mF2Kwg2KfZhNmF2YHYqtmI2K3YqQ!5e0!3m2!1sar!2ssa!4v1519731826443"></iframe>
                </div>
            </div>
            
            <div class="col-lg-6 col-md-6">
                <div class="contact-text">
                    <h3>Get in Touch</h3>
                    <p>OSIT puts together a bunch of passionate minds to transform your visions into reality imparting an awesome digital experience for your users. From website design, development, scalable mobile apps to SaaS platforms, the solution we engineer accelerate efficiency and fuel growth for our clients.</p>
                    <p>Whatever it may be, we are glad to hear from you!</p>
                    <ul class="social-links">
                        <li><a href="https://www.facebook.com/osit.com.sa/" target="_blank"><i class="icofont-facebook"></i></a></li>
                        <li><a href="https://twitter.com/osit_sa" target="_blank"><i class="icofont-twitter"></i></a></li>
                        <li><a href="https://www.instagram.com/osit_sa/" target="_blank"><i class="icofont-instagram"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/osit-sa/" target="_blank"><i class="icofont-linkedin"></i></a></li>
                    </ul>
                </div>
            </div>
            
            <div class="col-lg-6 col-md-6">
                <form id="contactForm" >
                    <div class="row">
                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="text" class="form-control" [(ngModel)]="name" [ngModelOptions]="{standalone: true}" placeholder="Name*">
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12">
                            <div class="form-group">
                                <input type="email" class="form-control" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" placeholder="Email*">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <input type="text" class="form-control" [(ngModel)]="subject" [ngModelOptions]="{standalone: true}" placeholder="Subject*">
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <textarea name="message" [(ngModel)]="message" class="form-control" [ngModelOptions]="{standalone: true}" id="message" cols="30" rows="4" placeholder="Your Message"></textarea>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <button (click)="onSubmit()" type="button" class="btn btn-primary">Send</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>
